import { useEffect, useState } from "react";
import { Zap, Send, Smartphone } from "lucide-react";
import { updateHotelManager, sendTarifExpressLink, fetchTarifExpressHistory } from "@/lib/api";
import { fmtPrice } from "@/lib/utils";

export const TarifExpressCard = ({ hotel }) => {
  const [phone, setPhone] = useState(hotel?.manager_phone || "");
  const [daily, setDaily] = useState(!!hotel?.tarif_sms_daily);
  const [adj, setAdj] = useState(hotel?.price_adjustment || null);
  const [history, setHistory] = useState([]);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setPhone(hotel?.manager_phone || ""); setDaily(!!hotel?.tarif_sms_daily); setAdj(hotel?.price_adjustment || null);
    if (hotel?.id) fetchTarifExpressHistory(hotel.id).then((d) => setHistory(d.items || [])).catch(() => {});
  }, [hotel]);

  const save = async (patch) => {
    setBusy(true); setMsg("");
    try {
      const r = await updateHotelManager(hotel.id, patch);
      setPhone(r.manager_phone || ""); setDaily(!!r.tarif_sms_daily); setAdj(r.price_adjustment || null);
      setMsg("Parametres enregistres");
    } catch (e) { setMsg(e?.response?.data?.detail || "Erreur"); } finally { setBusy(false); }
  };

  const sendNow = async () => {
    setBusy(true); setMsg("");
    try {
      const r = await sendTarifExpressLink(hotel.id);
      setMsg(r.ok ? `Lien envoye par SMS au ${r.sent_to}` : `SMS non envoye (${r.sms_info}) — lien : ${r.link}`);
    } catch (e) { setMsg(e?.response?.data?.detail || "Erreur d'envoi"); } finally { setBusy(false); }
  };

  return (
    <div className="glass-card p-5" data-testid="tarif-express-card">
      <div className="flex items-center gap-2 text-sm font-bold mb-1"><Zap size={16} className="text-orange-600" /> Tarif Express (lien magique par SMS)</div>
      <p className="text-xs text-[var(--ink-soft)] mb-4">Le gerant recoit un SMS avec un lien securise : il baisse ou augmente les prix du jour en 3 boutons, sans mot de passe.</p>
      {adj && adj.pct !== 0 && (
        <div className="mb-4 rounded-xl bg-orange-50 border border-orange-200 px-3 py-2 text-sm font-semibold text-orange-800" data-testid="tarif-express-active">
          Ajustement actif : {adj.pct > 0 ? "+" : ""}{adj.pct}% {adj.until ? `jusqu'au ${new Date(adj.until).toLocaleString("fr-FR")}` : "jusqu'a nouvel ordre"}
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_auto] gap-3 items-end">
        <div>
          <label className="inline-flex items-center gap-1"><Smartphone size={12} /> Telephone du gerant</label>
          <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+225 07 00 00 00 00" data-testid="manager-phone-input" />
        </div>
        <button onClick={() => save({ manager_phone: phone })} disabled={busy} className="btn-secondary" data-testid="manager-phone-save">Enregistrer</button>
        <button onClick={sendNow} disabled={busy || !phone} className="btn-primary inline-flex items-center gap-2" data-testid="tarif-express-send"><Send size={14} /> Envoyer le lien maintenant</button>
      </div>
      <label className="mt-4 inline-flex items-center gap-2 text-sm cursor-pointer">
        <input type="checkbox" checked={daily} onChange={(e) => { setDaily(e.target.checked); save({ tarif_sms_daily: e.target.checked }); }} className="!w-auto" data-testid="tarif-daily-toggle" />
        SMS automatique chaque matin a 7h (heure d&apos;Abidjan)
      </label>
      {msg && <div className="mt-3 text-sm font-semibold text-[var(--ink-soft)] break-all" data-testid="tarif-express-msg">{msg}</div>}
      {history.length > 0 && (
        <ul className="mt-4 text-xs divide-y divide-[var(--line)]" data-testid="tarif-express-history">
          {history.slice(0, 5).map((h, i) => (
            <li key={i} className="py-1.5 flex justify-between gap-2">
              <span>{new Date(h.at).toLocaleString("fr-FR")}</span>
              <span className="font-bold">{h.pct > 0 ? "+" : ""}{h.pct}% → {fmtPrice(h.new_price)}{h.rooms_available != null ? ` · ${h.rooms_available} ch.` : ""}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
